import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, Clock } from 'lucide-react';
import { getArticleBySlug } from '../data/articles';
export function ArticleDetailPage() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const article = slug ? getArticleBySlug(slug) : undefined;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);
  if (!article) {
    return <main className="flex-grow pt-32 pb-24 bg-ivory text-center px-6" data-id="element-373" data-mp="2w0p10hfjs5l4">
        <h1 className="text-4xl font-display font-bold text-midnight mb-6" data-id="element-374" data-mp="2r2x8bl72wffv">
          Article not found
        </h1>
        <Link to="/articles" className="inline-flex items-center gap-2 text-gold font-bold tracking-wide hover:text-midnight transition-colors" data-id="element-375" data-mp="352ol5iluzpsa">
          <ArrowLeft className="w-5 h-5" data-id="element-376" data-mp="1ao5gpahrbc7m" /> Back to Articles
        </Link>
      </main>;
  }
  return <main className="flex-grow pt-24" data-id="element-377" data-mp="15pkg39yleqin">
      <div className="bg-midnight text-ivory py-24 relative overflow-hidden" data-id="element-378" data-mp="15qm0w65eurdk">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-midnight-light to-transparent opacity-50 pointer-events-none" data-id="element-379" data-mp="1fgxpo4jz3rqa" />

        <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-380" data-mp="1kd4x61s0pbac">
          <Link to="/articles" className="inline-flex items-center gap-2 text-ivory/70 hover:text-gold transition-colors text-sm font-bold tracking-widest uppercase mb-12" data-id="element-381" data-mp="1pdk7ekh062o3">
            <ArrowLeft className="w-4 h-4" data-id="element-382" data-mp="1y64abx4buteq" /> All Articles
          </Link>

          <h1 className="text-4xl md:text-6xl font-display font-bold leading-tight tracking-tighter mb-8" data-id="element-383" data-mp="234xolrrfuofy">
            {article.title}
          </h1>

          <div className="flex items-center gap-4 text-ivory/60 text-sm font-bold uppercase tracking-wider" data-id="element-384" data-mp="282qx4rg7ruje">
            {article.author && <span data-id="element-385" data-mp="dr2eofarx9u9">{article.author}</span>}
            {article.author && <span className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-386" data-mp="dt5chli6479j" />}
            <span className="flex items-center gap-2" data-id="element-387" data-mp="iq5hru7715zl">
              <Clock className="w-4 h-4" data-id="element-388" data-mp="aoecsog24d8s" />
              {article.readTime}
            </span>
          </div>
        </div>
      </div>

      <section className="py-32 bg-ivory text-midnight" data-id="element-389" data-mp="5rnzu9zjtxrl">
        <div className="max-w-3xl mx-auto px-6" data-id="element-390" data-mp="knwwd3s21x0b">
          <article className="bg-white p-8 md:p-16 rounded-[3rem] shadow-xl border-2 border-midnight/5" data-id="element-391" data-mp="koona1apj6k9">
            <div className="w-16 h-2 bg-gold rounded-full mb-12" data-id="element-392" data-mp="fqdgy0jmfe6s" />

            <div className="font-medium leading-relaxed text-lg md:text-xl text-charcoal/80 space-y-8" data-id="element-393" data-mp="tmqwv58ib7j5">
              {article.paragraphs.map((p, i) => {
              if (typeof p === 'string') {
                return <p key={i} data-id="element-394" data-mp="13dbvgso6kc22">{p}</p>;
              }
              if (p.type === 'closing') {
                return <p key={i} className="font-serif italic text-midnight text-2xl md:text-3xl mt-12 leading-snug" data-id="element-395" data-mp="yh4mer0hmkfw">
                      {p.text}
                    </p>;
              }
              return <blockquote key={i} className="border-l-4 border-gold pl-8 py-2 font-serif italic text-midnight text-xl md:text-2xl bg-midnight/5 rounded-r-2xl" data-id="element-396" data-mp="1qzfgrgnnmbmm" data-mpi={i}>
                    {p.text}
                  </blockquote>;
            })}
            </div>
          </article>

          <div className="mt-16 text-center" data-id="element-397" data-mp="189pksq85njt4">
            <Link to="/articles" className="inline-flex items-center gap-2 text-midnight font-bold tracking-wide hover:text-gold transition-colors" data-id="element-398" data-mp="188xoteanbk2b">
              <ArrowLeft className="w-5 h-5" data-id="element-399" data-mp="z7zmd0fuvklu" /> Back to all articles
            </Link>
          </div>
        </div>
      </section>
    </main>;
}